import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './HeaderHint.css';

/** Popup width in px; mirrored by max-width in HeaderHint.css. */
const POPUP_WIDTH = 280;
const EDGE_GUTTER = 8;

/**
 * A small "?" after a column header that explains the column on hover, focus or tap.
 *
 * The popup is rendered into document.body rather than next to the header: the accuracy
 * tables sit in an overflow-x scroller, which clips any absolutely-positioned child —
 * including one that only overflows vertically.
 */
export default function HeaderHint({ text }) {
  const ref = useRef(null);
  const [pos, setPos] = useState(null);

  const show = () => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    const half = POPUP_WIDTH / 2;
    const centre = Math.min(
      Math.max(r.left + r.width / 2, half + EDGE_GUTTER),
      window.innerWidth - half - EDGE_GUTTER
    );
    setPos({ left: centre, top: r.bottom + 6 });
  };
  const hide = () => setPos(null);

  return (
    <>
      <span
        ref={ref}
        className="header-hint"
        tabIndex={0}
        role="button"
        aria-label={text}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
        onClick={(e) => { e.stopPropagation(); if (pos) hide(); else show(); }}
      >?</span>
      {pos && createPortal(
        <div className="header-hint-popup" role="tooltip" style={{ left: pos.left, top: pos.top }}>
          {text}
        </div>,
        document.body
      )}
    </>
  );
}
